module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-500.dd878ad0.woff";